import { getCookie } from 'cookies-next/client';

import { FORCE_VARIANT_FLAG_NAME } from '@/constants/cookies';
import { isServerCheck } from '@/modules/env/isServerCheck';

const headers = import('next/headers');

export async function getForceVariantCookie() {
  const headersFunction = await headers;

  if (isServerCheck()) {
    return (await headersFunction.cookies()).get(FORCE_VARIANT_FLAG_NAME)
      ?.value;
  }

  return getCookie(FORCE_VARIANT_FLAG_NAME);
}
